import { render, staticRenderFns } from "./straightDownPrice.vue?vue&type=template&id=d0646b12&scoped=true&"
import script from "./straightDownPrice.vue?vue&type=script&lang=js&"
export * from "./straightDownPrice.vue?vue&type=script&lang=js&"
import style0 from "./straightDownPrice.vue?vue&type=style&index=0&id=d0646b12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0646b12",
  null
  
)

export default component.exports